import { Session } from "./session";

export const isLoggedIn = () => {
  return !!Session.getToken();
};
